import { useState } from 'react';
import { Button, AritoIcon, DialogV2 } from '@/components/custom/erp';
import type { TaiKhoanCuaHang } from '@/types/schemas';

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  selectedObj: TaiKhoanCuaHang | null;
  clearSelection?: () => void;
  handleDelete: (uuid: string) => Promise<void>;
}

function DeleteDialog({ onClose, open, selectedObj, clearSelection, handleDelete }: DeleteDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  const onDeleteClick = async () => {
    if (!selectedObj?.uuid) {
      alert('Không tìm thấy dữ liệu để xóa');
      onClose();
      return;
    }

    try {
      setIsDeleting(true);
      await handleDelete(selectedObj.uuid);
      if (clearSelection) {
        clearSelection();
      }
      onClose();
    } catch (error) {
      console.error('Error deleting store account:', error);
    } finally {
      setIsDeleting(false);
    }
  };
  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Xóa dữ liệu'
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={260} />}
      actions={
        <>
          <Button
            className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]'
            onClick={onDeleteClick}
            type='submit'
            form='search-form'
            disabled={isDeleting}
          >
            <AritoIcon icon={884} marginX='4px' />
            {isDeleting ? 'Đang xóa...' : 'Đồng ý'}
          </Button>
          <Button onClick={onClose} variant='outline' disabled={isDeleting}>
            <AritoIcon icon={885} marginX='4px' />
            Huỷ
          </Button>
        </>
      }
    >
      <p className='min-w-96 p-4 text-base font-medium'>Bạn có chắc chắn xóa không?</p>
    </DialogV2>
  );
}

export default DeleteDialog;
